export default __webpack_public_path__ + "static/media/0.a2ba52a3.png";